import React, { Component } from 'react'

import round from 'lodash/round'

import applicationConstants from '../../../../../utils/constants/application'
import { getCompanyLogoUrl } from '../../../../../utils/routing/externalLinks'
import { capitalize } from '../../../../../utils/string'

import ResultCaret, { caretOrientations } from './components/ResultCaret'

class SalaryDataResultCard extends Component {
  render() {
    const { title, name, salary, onClick, isActive, companyId, hasIcon } = this.props
    const addDefaultSrc = e => {
      if (e.target.src !== applicationConstants.building_icon_url) {
        e.target.src = applicationConstants.building_icon_url
      }
    }

    return (
      <div style={{ padding: '10px 0' }}>
        <div
          className={`view-div salary ${isActive ? 'shadow' : ''}`}
          onClick={onClick}
          style={{
            padding: '10px 5px',
            margin: '0 -5px',
            backgroundColor: isActive ? '#EFF5FC' : '',
          }}
        >
          <h6 className="color-blue">{title}</h6>
          <div style={{ display: 'flex' }}>
            <h6
              className="mb-0"
              title="Annual Salary"
              style={{ height: '2.5em', overflow: 'hidden' }}
            >
              {capitalize(name)}
            </h6>
          </div>
          {hasIcon && (
            <div className="text-center">
              <div className="company-logo-container" style={{ margin: '0 auto' }}>
                <img
                  src={getCompanyLogoUrl(companyId)}
                  onError={addDefaultSrc}
                  alt="company logo"
                  className="company-logo"
                />
              </div>
            </div>
          )}

          {salary && (
            <h2
              style={{ margin: '5px 0', fontSize: 35 }}
              className="text-center mb-0 color-green"
              title="Salary in Thousands"
            >
              <sup className="text-muted" style={{ fontSize: 20 }}>
                $
              </sup>
              {round(salary / 1000, 0)}
              <span style={{ fontSize: 18 }}>K</span>
            </h2>
          )}
          <div style={{ paddingRight: 15 }} className="card-click-icon">
            <ResultCaret activeOrientation={caretOrientations.down} active={isActive} />
          </div>
        </div>
      </div>
    )
  }
}

export default SalaryDataResultCard



// WEBPACK FOOTER //
// ./src/routes/authenticated/Search/routes/components/SalaryDataResultCard.js